module.exports = __webpack_public_path__ + "static/media/bg-login.36449790.jpg";